module.exports = __webpack_public_path__ + "pdk8-16.jpg?6fa5eb7179b43402a43b0d6c6b41d127";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/pdk8-16.jpg
// module id = 77
// module chunks = 0